export const NOT_FOUND = 'CARD-NOT-FOUND-404'
